// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"4137da88","370":"e72f81fb","774":"e72f81fb"}[chunkId] + ".chunk.css";
};